<template>
  <div class="remind-list">
    <div class="remind-list-item" v-for="(item, index) in dataList" :key="item.Id">
      <div class="list-img" @click="entoDetailPage(item.ProductID, item.IsInSaleSort, item.IsStockNoZero, item.FreeCardNum, index)">
        <img v-lazy="item.PicUrl" alt="" :key="item.ProductID" />
        <!-- 抢光啦 -->
        <div class="soldout-mask" v-if="!item.IsStockNoZero">
          <p>Sorry</p>
          <p>抢光啦</p>
        </div>
      </div>
      <div class="list-cnt">
        <div class="list-cnt-title" @click="entoDetailPage(item.ProductID, item.IsInSaleSort, item.IsStockNoZero, item.FreeCardNum, index)">
          <div class="title oneRow">
            <div class="l-freecard-tag" v-if="item.FreeCardNum !== null">
              <span>免单卡</span>
              <span>{{ isNewcomer ? 1 : item.FreeCardNum }}</span>
            </div>
            <span>{{ item.TitleShort || '----' }}</span>
          </div>
          <template v-if="item.ScareBuyNodeList">
            <div class="remind-time">
              <span>抢购时间：</span>
              <div class="remind-time-item" v-for="(item, i) in item.ScareBuyNodeList" :key="i">
                <span>{{ item.GapDay === 1 ? '次日' : '' }}{{ item.Node }}</span>
              </div>
            </div>
          </template>
        </div>
        <div class="list-cnt-btm">
          <div class="list-btm-price"><span>￥</span>{{ item.IsFreeCard ? '0' : item.RealDiscountPrice }}</div>
          <div v-show="!getManageBtnIsOpen" class="flex">
            <button class="list-btm-btn cancel" @click="shareClick(item.ProductId)">
              分享好友
            </button>
            <button class="list-btm-btn" v-if="!item.IsStockNoZero && item.ScareBuyNodeList && getIsShowRemindBtn" @click="$emit('remindBtnHandler', { index, item })">
              {{ item.ScareBuyNodeList | IsPrePurchaseFilter }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Checkbox, CheckboxGroup } from 'vant'
import { Toast, Indicator } from 'mint-ui'
import { IsExistTaskCanAccept } from '@/api/souhuo'
import { mapGetters } from 'vuex'

export default {
  components: {
    'van-checkbox': Checkbox,
    'van-checkbox-group': CheckboxGroup
  },
  props: {
    dataList: {
      type: Array,
      require: true,
      default: function() {
        return []
      }
    },
    // 是否是新人
    isNewcomer: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  computed: {
    ...mapGetters(['getManageBtnIsOpen', 'getIsShowRemindBtn'])
  },
  methods: {
    entoDetailPage(productID, isInSaleSort, IsStockNoZero, FreeCardNum, index) {
      // 收藏夹管理按钮打开状态不能进入商品详情
      if (this.getManageBtnIsOpen) return
      let isFreeCard = false
      if (FreeCardNum !== null) isFreeCard = true
      // this.$emit('entoDetailPage', productID, isInSaleSort, isFreeCard)
      // 存在特卖排序表并且已登录的情况
      if (isInSaleSort && IsStockNoZero && this.$store.getters.loginState) {
        Indicator.open({
          text: '加载中',
          spinnerType: 'triple-bounce'
        })
        IsExistTaskCanAccept({ productID: productID })
          .then((res) => {
            Indicator.close()
            if (res.Msg !== 'False') {
              this.$emit('entoDetailPage', productID, isFreeCard)
            } else {
              // 主图变更为被抢光
              this.picAddNoStock(index)
            }
          })
          .catch((res) => {
            Indicator.close()
            if (res.ErrMsg) {
              Toast(res.ErrMsg)
            }
          })
        // 无库存，未登录
      } else {
        this.$emit('entoDetailPage', productID, isFreeCard)
      }
    },
    // 分享好友
    shareClick(productId) {
      this.$emit('shareClick', productId)
    },
    picAddNoStock(index) {
      Toast('商品已经被抢光啦')
      this.$set(this.dataList[index], 'IsInSaleSort', false)
    }
  },
  filters: {
    IsPrePurchaseFilter(tempArr) {
      const res = tempArr.find((item) => item.IsPrePurchase === true)
      return res ? '取消提醒' : '预约提醒'
    }
  }
}
</script>

<style scoped lang="scss">
.remind-list {
  background: linear-gradient(to bottom, #fff 0, #f1f1f1 300px, #f1f1f1);
}
.remind-list-item {
  position: relative;
  display: flex;
  align-items: center;
  height: 125px;
  width: 100%;
  box-sizing: border-box;
  padding: 8px 3%;
  background: #fff;
  margin-top: 10px;
}
.remind-list-item:first-child {
  margin-top: 0;
}
.checkBoxBox {
  display: flex;
  align-items: center;
  // justify-content: space-around;
  width: 40px;
  flex-shrink: 0;
}
.list-img {
  position: relative;
  width: 109px;
  height: 100%;
  flex-shrink: 0;
}
.list-img img {
  display: block;
  height: 100%;
  width: 100%;
  border-radius: 3px;
  object-fit: cover;
}
.list-cnt {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-left: 10px;
  flex-grow: 1;
  height: 100%;
}
.list-cnt-title {
  height: 75%;
  overflow: hidden;
}
.list-cnt-title > .title {
  width: 90%;
  margin-bottom: 2%;
}
.list-cnt-title .remind-time {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  color: #999;
  font-size: 12px;
  margin-top: 3px;
  padding-left: 60px;
  box-sizing: border-box;
  height: 40px;
  overflow: hidden;
}
.remind-time > span {
  display: flex;
  align-items: center;
  justify-content: space-around;
  flex-shrink: 0;
  position: absolute;
  left: 0;
  top: 0;
  height: 16px;
}
.remind-time-item > span {
  display: flex;
  align-items: center;
  justify-content: space-around;
  background: #f0f0f0;
  padding: 0 4px;
  box-sizing: border-box;
  margin-bottom: 4px;
  margin-right: 4px;
  color: #aaa;
  border-radius: 3px;
  font-size: 12px;
  line-height: 12px;
  height: 16px;
}
.list-cnt-btm {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
}
.list-btm-price {
  color: #f23030;
  font-size: 20px;
  line-height: 20px;
}
.list-btm-price > span {
  font-size: 12px;
  font-weight: 600;
}
.list-btm-btn {
  width: 80px;
  line-height: 22px;
  text-align: center;
  color: #f23030;
  background: #fff;
  border: 1px solid #f23030;
  padding: 2px 0;
  margin-left: 5px;
  border-radius: 15px;
}
.list-btm-btn:active {
  opacity: 0.8;
}
.list-btm-btn.cancel {
  color: #333;
  border-color: #333;
}
.delete-icon {
  position: absolute;
  top: 2px;
  right: 10px;
  width: 30px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  color: #999;
  border-radius: 50%;
  font-size: 18px;
}
.delete-icon .icon {
  font-size: 18px;
}
.delete-icon:active {
  background: #f5f5f5;
}
@media screen and (max-width: 320px) {
  .list-btm-btn {
    width: 72px;
    line-height: 20px;
  }
}
.l-freecard-tag {
  position: relative;
  top: -1px;
  margin-right: 4px;
}
</style>
